import React, { Component } from "react";
import { getSdk } from "../../services/sdkService";
import { config } from "../../config/config";
import { Text, Input, KeyboardSwap, withFocusable } from "../../services/visualLibraryService";
import { i18n } from "../../services/i18nService";
import { withAppState, getAppState } from "../../state";
import {
  ParentalControlStyled,
  ContainerParentalStyled,
  BlockStyled,
  ButtonsGroupStyled,
  KeyButtonStyled
} from "./styles/Styled";
import { HeadingStyled } from "../../styles/shared-styles";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getGlobalButtonFocusPath, getGlobalButtonInfo } from "../../errors/globalButtons";
import { trackPage, setParentalValue, trackEvent } from "../../services/analyticsService";
import * as Sentry from "@sentry/browser";

const TYPE_PASSWORD = "password";
const PAGE = "parentalControl";
const KeyButtonStyledFocus = withFocusable(KeyButtonStyled);

class ParentalControl extends Component {
  constructor(props) {
    super(props);
    try {
      this.parentalLevel = this.props.location.state.parentalLevel;
    } catch (e) {
      Sentry.captureException(e);
      throw Error("Must come from Settings/ParentalControl");
    }
    this.pwdInput = React.createRef();
    this.state = {
      pwd: "",
      active: this.pwdInput,
      passInputType: TYPE_PASSWORD
    };
    this.updateValue = this.updateValue.bind(this);
    this.keyboardDidSwap = this.keyboardDidSwap.bind(this);
    this.send = this.send.bind(this);
  }

  componentDidMount() {
    trackPage(PAGE);
  }

  updateValue(value) {
    this.setState({ pwd: value });
  }

  keyboardDidSwap({ defaultFocusPath }) {
    this.props.setFocus(defaultFocusPath);
  }

  checkNextButtonDisability() {
    return this.state.pwd.length < config.get().minPassLength;
  }

  async send() {
    const sdk = await getSdk();
    try {
      await this.props.stateActions.setParentalLevel(this.parentalLevel, this.state.pwd);
      setParentalValue(this.parentalLevel);
      trackEvent("settings", "parental level change", this.parentalLevel);
      this.props.history.goBack();
      // this.props.history.push("/settings") // refresh the page as reset the data of settings page
    } catch (e) {
      Sentry.captureException(e);
      if (e.status && e.status === 400) {
        this.props.stateActions.showGlobalModal({
          modalText: i18n.get("pages.parentalControl.wrongPassword"),
          buttons: [
            {
              ...getGlobalButtonInfo("close"),
              buttonHandler: this.props.stateActions.hideGlobalModal
            }
          ]
        });
        this.props.setFocus(getGlobalButtonFocusPath("close"));
      } else {
        const online = !!getAppState().isOnline;
        const errorText = online
          ? i18n.get("global.errors.genericError")
          : i18n.get("global.errors.internetConnectivity.text");
        this.props.stateActions.showGlobalModal({
          modalText: errorText,
          modalTitle: !online && i18n.get("global.errors.internetConnectivity.title"),
          buttons: [
            {
              ...getGlobalButtonInfo("retry"),
              buttonHandler: async () => {
                this.props.stateActions.hideGlobalModal();
                if (!online) {
                  await this.send();
                } else {
                  this.componentDidMount.bind(this);
                }
              }
            },
            {
              ...getGlobalButtonInfo(`exit`),
              buttonHandler: sdk.systemManager.application.exit
            }
          ]
        });
        this.props.setFocus(getGlobalButtonFocusPath("retry"));
      }
    }
  }

  render() {
    return (
      <ParentalControlStyled>
        <HeadingStyled rank={1} text={i18n.get("pages.parentalControl.title")} />
        <ContainerParentalStyled>
          <BlockStyled>
            <Text text={i18n.get("pages.parentalControl.enterPassword")} />
            <KeyboardSwap
              text={this.state.pwd}
              onChange={this.updateValue}
              direction={i18n.getDirection()}
              onSwap={this.keyboardDidSwap}
              showEmailKeys={false}
              width={"35vw"}
            />
            <ButtonsGroupStyled>
              <KeyButtonStyledFocus
                disabled={this.checkNextButtonDisability()}
                onEnterPress={this.send}
                focusPath={"parentalControlNextButton"}
              >
                {i18n.get("global.next")}
              </KeyButtonStyledFocus>
            </ButtonsGroupStyled>
          </BlockStyled>
          <BlockStyled>
            <Input
              id={"password-input"}
              type={this.state.passInputType}
              ref={this.pwdInput}
              value={this.state.pwd}
              placeholder={i18n.get("global.credentials.password")}
              active={this.state.active === this.pwdInput}
              readOnly
            />
          </BlockStyled>
        </ContainerParentalStyled>
      </ParentalControlStyled>
    );
  }
}

ParentalControl.defaultFocusPathLTR = KeyboardSwap.defaultFocusPathLTR;
ParentalControl.defaultFocusPathRTL = KeyboardSwap.defaultFocusPathRTL;
ParentalControl.defaultFocusPath = KeyboardSwap.defaultFocusPath;

export default withAppState(withSubtheme(ParentalControl));
